<template>
  <div class="four_section">
    <h1>我们的优势</h1>
    <div class="advantage_wrapper">
      <div class="item">
        <img src="../../assets/home/youshi-1.webp" alt="advantage1" />
        <p>多年技术积累，SDK简易快速上手</p>
      </div>
      <div class="item">
        <img src="../../assets/home/youshi-2.webp" alt="advantage2" />
        <p>深度开放+服务响应速度快</p>
      </div>
      <div class="item">
        <img src="../../assets/home/youshi-3.webp" alt="advantage3" />
        <p>安卓/苹果/PC全线技术支持</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.four_section {
  width: 100%;
  h1 {
    margin-top: 80px;
    margin-bottom: 100px;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
  }
  .advantage_wrapper {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 80px;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        max-width: 147px;
        height: auto;
      }
      p {
        margin-top: 30px;
        font-size: 20px;
        font-weight: 400;
        color: #0d0e24;
      }
    }
  }
}
</style>